




















































	import { Component, Vue } from 'vue-property-decorator'
	import HeadLable from '@/components/HeadLable/index.vue'
	import { getAdminUserList, enableOrDisableAdminUser } from '@/api/adminuser'
	import { UserModule } from '@/store/modules/user'
	import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
	import Empty from '@/components/Empty/index.vue'
  import { queryLevel } from '@/api/order'

	@Component({
		name: 'adminuser',
		components: {
			HeadLable,
			InputAutoComplete,
			Empty,
		},
	})
	export default class extends Vue {
		private input : any = ''
		private counts : number = 0
		private page : number = 1
		private pageSize : number = 10
		private tableData = []
		private id = ''
		private status = ''
		private isSearch : boolean = false
    private level = 4

		created() {
      this.getLevel()
			this.init()
		}

		initProp(val) {
			this.input = val
			this.initFun()
		}

		initFun() {
			this.page = 1
			this.init()
		}

		get userName() {
			return UserModule.username
		}
    getLevel(){
      const username = UserModule.username

      queryLevel(username)
        .then((res)=>{
          if (res.data.code === 1) {
            this.level=res.data.data
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    }

		private async init(isSearch ?: boolean) {
			this.isSearch = isSearch
			const params = {
				page: this.page,
				pageSize: this.pageSize,
				name: this.input ? this.input : undefined,
			}
			await getAdminUserList(params)
				.then((res : any) => {
					if (String(res.data.code) === '1') {
						this.tableData = res.data && res.data.data && res.data.data.records
						this.counts = res.data.data.total
					}
					// if (!res.data.data.records.length && type === 'search') {
					//   this.$message.error('未搜索到相关员工，请核对员工姓名是否正确')
					// }
				})
				.catch((err) => {
					this.$message.error('请求出错了：' + err.message)
				})
		}

		// 添加
		private AdminUserHandle(st : string, username : string) {
			if (st === 'add') {
				this.$router.push({ path: '/AdminUser/add' })
			} else {
				if (username === 'admin') {
					return
				}
				this.$router.push({ path: '/AdminUser/add', query: { id: st } })
			}
		}

		//状态修改
		private statusHandle(row : any) {
			if (row.username === 'admin') {
				return
			}
			this.id = row.id
			this.status = row.status
			this.$confirm('确认调整该账号的状态?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				enableOrDisableAdminUser({ id: this.id, status: !this.status ? 1 : 0 })
					.then((res) => {
						if (String(res.status) === '200') {
							this.$message.success('账号状态更改成功！')
							this.init()
						}
					})
					.catch((err) => {
						this.$message.error('请求出错了：' + err.message)
					})
			})
		}

		private handleSizeChange(val : any) {
			this.pageSize = val
			this.init()
		}

		private handleCurrentChange(val : any) {
			this.page = val
			this.init()
		}
	}
